<template>
  <div>
    <h2 class="title" v-if="State.isPartner === false">Stel uw eigen pakket in 5 stappen samen</h2>

    <postcode-check v-on="$listeners" />
  </div>
</template>

<script>
import PostcodeCheck from '../components/postcode-check'
import State from '../state'
export default {
  components: { PostcodeCheck },
  data () {
    return {
      State
    }
  },
}
</script>
